module.exports = __webpack_public_path__ + "img/bus1.6b022442.png";